export default __webpack_public_path__ + "static/media/T_59_mobile.a524d835.jpg";